import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  pageName: {
    fontWeight: 700
  },
  skeletonPageName: {
    maxHeight: 10,
    height: 10,
    margin: 0
  }
})

export default useStyles
